import { IAPIRoutes } from "../../../../config";

export type IDeviceRepository = ReturnType<typeof DeviceRepositoryFactory>;

export const DeviceRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET, POST } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getDeviceConnectionStatusAPI: IGetDeviceConnectionStatusAPI = async (
    payload
  ) =>
    GET(
      APIRoutes.apiGetDeviceConnectionStatus.replace(
        "{device_id}",
        payload.device_id
      ),
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const verifyDeviceAPI: IVerifyDeviceAPI = async (payload) =>
    POST(
      APIRoutes.apiVerifyDevice,
      {
        device_id: payload.device_id,
        proof: payload.proof,
        ...(payload.device_db_id !== undefined
          ? { device_db_id: payload.device_db_id }
          : {}),
        ...(payload.inventory_id !== undefined
          ? { inventory_id: payload.inventory_id }
          : {}),
      },
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const registerDeviceAPI: IRegisterDeviceAPI = async ({
    clinic_id,
    device_id,
  }) =>
    POST(
      APIRoutes.apiRegisterDevice.replace("{clinic_id}", String(clinic_id)),
      { clinic_id, device_id },
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  return {
    getDeviceConnectionStatusAPI,
    verifyDeviceAPI,
    registerDeviceAPI,
  };
};
